<template>
  <layout-view navTitle="Схемы расчета зарплат">
    <template v-slot:nav>
      <com-branch-autocomplete-single class="mx-4 mt-1" :select.sync="comBranch"/>
      <progress-page v-if="salarysState.isLoading" />
      <v-list v-else dense class="py-0">
        <v-list-item
            v-for="(v, i) in comBranch===null ? salarys : salarys.filter(v1=>v1.comBranch===null || parseInt(v1.comBranch.id)===comBranch.id)" :key="i"
            @click="salarySelect(v)"
            :class="v.id===salary.id ? 'v-list-item--active' : ''">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="auto" align-self="center">
                <v-list-item-title>{{$tools.date(v.begin)}}</v-list-item-title>
              </v-col>
              <v-col>
                <chip v-if="v.comBranch!==null" small :color="v.comBranch.color" dark class="ml-2">{{v.comBranch.name}}</chip>
              </v-col>
              <v-col cols="auto">
                <chip v-if="v.status==='active'" small color="success" dark>Активен</chip>
              </v-col>
              <v-col v-if="v.salaryTemplate!==null" cols="12" class="caption mt-1">
                <chip small>Привязан профиль: {{v.salaryTemplate.name}}</chip>
              </v-col>
              <v-col v-if="!$tools.isEmpty(v.comment)" cols="12" class="caption mt-1">
                <v-icon class="mr-1" small>mdi-comment-text-outline</v-icon>
                {{v.comment}}
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <template v-slot:content="{height}">
      <v-toolbar class="bar" dense elevation="0" color="transparent" max-height="48px">
        <v-toolbar-title class="body-2 font-weight-medium mr-2">Схема расчета зарплаты</v-toolbar-title>
        <v-spacer/>
        <v-btn v-if="salary.salaryTemplate===null" small depressed class="mr-2" @click="salaryTemplatesAttachOpen=true">Привязать профиль</v-btn>
        <btn-small-accept v-if="salary.salaryTemplate!==null" btn-class="mr-2" name="Отвязать профиль" text="Вы уверены что хотите отвязать схему от профиля?" small depressed class="mr-2" @accept="salaryDetach()"/>
        <salary-templates name="Привязать профиль" :open.sync="salaryTemplatesAttachOpen" @selected="(v)=>{salaryAttach=v;}"/>

        <v-btn :disabled="salary.salaryTemplate!==null" small depressed class="mr-2" @click="salaryTemplatesOpen=true">Загрузить профиль</v-btn>
        <salary-templates name="Загрузить профиль" :open.sync="salaryTemplatesOpen" @selected="(v)=>{salary=v;salary.salaryTemplate=null;salary.salaryServices=v.salaryTemplateServices}"/>
        <v-btn :disabled="salary.salaryTemplate!==null" small depressed class="mr-2" @click="salaryTemplatesDeleteOpen=true">Удалить профиль</v-btn>
        <salary-template-delete :open.sync="salaryTemplatesDeleteOpen"/>

        <v-btn small depressed @click="salaryTemplatesSaveOpen=true">Сохранить профиль</v-btn>
        <salary-templates-save :open.sync="salaryTemplatesSaveOpen" :salary="salary"/>
        <dot/>
        <btn-small-accept name="Удалить" btnClass="mr-2" @accept="salaryDelete()" text="Рекомендуется удалять только если схема была создана по ошибке"/>
        <v-btn @click="salarySave()" :loading="salarySaveState.isLoading" small depressed color="primary">Сохранить</v-btn>
      </v-toolbar>

      <transition name="fade">
        <SalaryForm :salary.sync="salary" :height="height" v-if="salarysState.isSuccess"/>
      </transition>

    </template>
  </layout-view>

</template>

<script>
import State from "@/plugins/state";
import Api from "@/Api";
import LayoutView from "@/components/LayoutView.vue";
import ComBranchAutocompleteSingle from "@/componentsV2/custom/ComBranchAutocompleteSingle.vue";
import moment from "moment";
import axios from "axios";
import SalaryForm from "@/views/Salary/SalaryForm.vue";
import SalaryTemplatesSave from "@/views/Salary/SalaryTemplatesSave.vue";
import SalaryTemplates from "@/views/Salary/SalaryTemplates.vue";
import SalaryTemplateDelete from "@/views/Salary/SalaryTemplateDelete.vue";
import Dot from "@/componentsV2/base/Dot.vue";
import BtnSmallAccept from "@/componentsV2/base/BtnSmallAccept.vue";

import Chip from "@/componentsV2/base/Chip.vue";
import {
  Entity_ComBranch,
  Entity_Salary, Entity_SalaryService,
  Entity_SalaryTemplate,
  Entity_SalaryTemplateService,
  Entity_Service,
  Entity_User
} from "../../../EntityStoreCacheService";
import ProgressPage from "@/components/ProgressPage.vue";


export default {
  components: {
    ProgressPage,
    Chip,
    Dot,
    SalaryForm,
    SalaryTemplateDelete,
    SalaryTemplates,
    SalaryTemplatesSave,
    LayoutView,
    ComBranchAutocompleteSingle,
    BtnSmallAccept 
  },
  data: () => ({
    comBranch:null,
    salarys:[],
    salary:{},
    salarysState:new State(),

    salarySaveState:new State(),

    templates:[],
    salaryAttach:null,
    salaryTemplatesAttachOpen:false,
    salaryTemplatesOpen:false,
    salaryTemplatesDeleteOpen:false,
    salaryTemplatesSaveOpen:false,
  }),
  watch:{
    salaryAttach(){
      if(this.salaryAttach!==null)
        this.salaryAttachAction();
    }
  },
  mounted() {
    this.salaryListLoad(()=>{
      if(this.salarys.length>0)
        this.salarySelect(this.salarys[0]);
    });
  },
  methods: {
    salaryListLoad(callback=null){
      new Entity_Salary()
          .selects(Entity_Salary.id)
          .selects(Entity_Salary.comment)
          .selects('status')
          .selects(Entity_Salary.begin)
          .selects(Entity_Salary.createVisitMode)
          .selects(Entity_Salary.createVisit)
          .selects(Entity_Salary.renMode)
          .selects(Entity_Salary.ren)
          .selects(Entity_Salary.refMode)
          .selects(Entity_Salary.ref)
          .selects(Entity_Salary.regMode)
          .selects(Entity_Salary.reg)
          .selects(Entity_Salary.rateMode)
          .selects(Entity_Salary.rate)
          .selects(Entity_Salary.rateMaxMode)
          .selects(Entity_Salary.rateMax)
          .selects(Entity_Salary.isRateServiceDiscount)
          .selects(Entity_Salary.isCountingFromMargin)       
          .selects([Entity_Salary.comBranch, Entity_ComBranch.id].join('.'))
          .selects([Entity_Salary.comBranch, Entity_ComBranch.name].join('.'))
          .selects([Entity_Salary.comBranch, Entity_ComBranch.color].join('.'))
          .selects([Entity_Salary.salaryServices, Entity_SalaryService.renMode].join('.'))
          .selects([Entity_Salary.salaryServices, Entity_SalaryService.ren].join('.'))
          .selects([Entity_Salary.salaryServices, Entity_SalaryService.service, Entity_Service.id].join('.'))
          .selects([Entity_Salary.salaryServices, Entity_SalaryService.service, Entity_Service.name].join('.'))
          .selects([Entity_Salary.salaryServices, Entity_SalaryService.service, Entity_Service.priceTotal].join('.'))

          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.id].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.name].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.comment].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.createVisitMode].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.createVisit].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.renMode].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.ren].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.refMode].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.ref].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.regMode].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.reg].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.rateMode].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.rate].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.rateMaxMode].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.rateMax].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.isRateServiceDiscount].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.isCountingFromMargin].join('.'))       
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.renMode].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.ren].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.service, Entity_Service.id].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.service, Entity_Service.name].join('.'))
          .selects([Entity_Salary.salaryTemplate, Entity_SalaryTemplate.salaryTemplateServices, Entity_SalaryTemplateService.service, Entity_Service.priceTotal].join('.'))
          .order(Entity_Salary.begin, false)
          .filterAnd([Entity_Salary.entity, Entity_Salary.user, Entity_User.id].join('.')+'=?', this.$router.currentRoute.params.id)
          .page(1)
          .onPage(1000)
          .addStateCallback((v)=> this.salarysState.setRequestBuilderState(v))
          .addStateCallback((r)=>{
            if(r.success){
              this.salarys = r.items;
              this.salarys.forEach(v=>{
                if(v.salaryTemplate!==null){
                  v.comment = v.salaryTemplate.comment;
                  v.createVisitMode = v.salaryTemplate.createVisitMode;
                  v.createVisit = v.salaryTemplate.createVisit;
                  v.renMode = v.salaryTemplate.renMode;
                  v.createVisit = v.salaryTemplate.createVisit;
                  v.ren = v.salaryTemplate.ren;
                  v.refMode = v.salaryTemplate.refMode;
                  v.ref = v.salaryTemplate.ref;
                  v.regMode = v.salaryTemplate.regMode;
                  v.reg = v.salaryTemplate.reg;
                  v.rateMode = v.salaryTemplate.rateMode;
                  v.rate = v.salaryTemplate.rate;
                  v.rateMaxMode = v.salaryTemplate.rateMaxMode;
                  v.rateMax = v.salaryTemplate.rateMax;
                  v.isRateServiceDiscount = v.salaryTemplate.isRateServiceDiscount;
                  v.isCountingFromMargin =  v.salaryTemplate.isCountingFromMargin
                  v.salaryServices = v.salaryTemplate.salaryTemplateServices;
                }
              })
              if(callback!==null)
                callback();
            }
          })
          .request()
    },
    salarySave(){
      this.salarySaveState.stateLoading();
      let data = this.$tools.copy(this.salary)
      data.userId = parseInt(this.$router.currentRoute.params.id)
      data.begin = moment(this.salary.begin, 'DD.MM.YYYY').format('YYYY-MM-DD')
      data.comBranchId = typeof data.comBranch==='undefined' || data.comBranch===null ? null : data.comBranch.id;
      delete data.comBranch;
      data.salaryTemplateId = this.salary.salaryTemplate===null ? null : this.salary.salaryTemplate.id;
      delete data.salaryTemplate;

      if(this.salary.salaryServices.filter(v=>typeof v.renMode==='undefined').length>0){
        this.$store.commit('alertError', 'Не у всех услуг задан тип');
        return null;
      }

      axios.post(Api.host+'/salary/', data).then(()=>{
        this.salarySaveState.stateSuccess();
        this.$store.commit('alertSuccess', 'Схема обновлена');
        this.salaryListLoad();
      }).catch(()=>{
        this.salarySaveState.stateError();
      });
    },
    salaryDelete(){
      this.salarySaveState.stateLoading();
      axios.delete(Api.host+'/salary/'+this.salary.id+'/').then(()=>{
        this.salarySaveState.stateSuccess();
        this.$store.commit('alertSuccess', 'Схема удалена');
        this.salaryListLoad();
      }).catch(()=>{
        this.salarySaveState.stateError();
      });
    },
    salaryAttachAction(){
      let data = this.$tools.copy(this.salary)

      axios.put(Api.host+'/salary/',{
        userId: parseInt(this.$router.currentRoute.params.id),
        begin: moment(this.salary.begin, 'DD.MM.YYYY').format('YYYY-MM-DD'),
        comBranchId: typeof data.comBranch==='undefined' || data.comBranch===null ? null : data.comBranch.id,
        salaryTemplateId: this.salaryAttach.id
      }).then((r)=>{
        this.salarySaveState.stateSuccess();
        this.salaryListLoad(()=>{
          this.salarySelect(this.salarys.filter(v=>v.id===r.data.salaryId)[0]);
        });
        this.$store.commit('alertSuccess', 'Схема привязана к профилю');
      }).catch(()=>{
      });
    },
    salaryDetach(){
      axios.put(Api.host+'/salary/'+this.salary.id+'/detach/').then(()=>{
        this.salaryListLoad(()=>{
          this.salarySelect(this.salarys.filter(v=>v.id===this.salary.id)[0]);
        });
        this.$store.commit('alertSuccess', 'Схема отвязана от профиля');
      }).catch(()=>{
      });
    },
    salarySelect(v){
      this.salary=this.$tools.copy(v);
      this.salary.begin=this.$tools.dateTimeFormat(this.$tools.copy(v).begin,'DD.MM.YYYY');
      if(this.salary.comBranch!==null)
        this.salary.comBranch.id = parseInt(this.salary.comBranch.id)
      this.salary.salaryServices = this.salary.salaryServices.sort((a,b)=>a.service.name.localeCompare(b.service.name));
    }
  }
};
</script>